import React from "react";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";
import { StickyCTA, StickyCTAMobile } from "./StickyCTA";

export const Layout = ({ children }) => {
    return (
        <div className="min-h-screen flex flex-col bg-brand-stone">
            <Navbar />
            <main className="flex-1">{children}</main>
            <Footer />
            <StickyCTA />
            <StickyCTAMobile />
        </div>
    );
};
